import { render, staticRenderFns } from "./usuarios.vue?vue&type=template&id=b2af906a"
import script from "./usuarios.vue?vue&type=script&lang=js"
export * from "./usuarios.vue?vue&type=script&lang=js"
import style0 from "./usuarios.vue?vue&type=style&index=0&id=b2af906a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports